import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import LoginPage from "@/pages/LoginPage";
import SurveyToolbox from "@/pages/SurveyToolbox";

/**
 * Gate — bootstraps the auth session and routes:
 *   - undefined  → still checking, show a splash
 *   - null       → not logged in, show LoginPage
 *   - object     → logged in, show SurveyToolbox
 */
function Gate() {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0A0B0E]">
        <div className="text-[10px] uppercase tracking-[0.3em] text-[#4A5054]">
          Initialising…
        </div>
      </div>
    );
  }
  if (user === null) return <LoginPage />;
  return <SurveyToolbox />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Gate />} />
            <Route path="*" element={<Gate />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#121418",
              border: "1px solid #2a2f3a",
              color: "#e2e8f0",
              fontFamily: "Chakra Petch, sans-serif",
              letterSpacing: "0.08em",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
